import { render } from "./ChallengesDialog.vue?vue&type=template&id=53d29392"
import script from "./ChallengesDialog.vue?vue&type=script&lang=js"
export * from "./ChallengesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__